import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, track, trackPageview } from "@/lib/analytics";

/**
 * Starts cookie-free analytics once, sends a pageview on every route change,
 * and counts every "Get visa help" click (any link to /start), with the
 * page and the section it sits in, so we know which button works.
 */
export function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
    const onClick = (e: MouseEvent) => {
      const link = (e.target as Element | null)?.closest?.('a[href^="/start"], a[href$="#plan"]');
      if (!link) return;
      const where = link.closest("nav, footer, section[id], header");
      track("cta_start_application", {
        page: window.location.pathname,
        from: where ? where.id || where.tagName.toLowerCase() : "page",
      });
    };
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);

  return null;
}
